/* Vazzari – header logo fail-safe (19 Oct 2026). NEW file; revert = remove its tag from layout/theme.liquid.
   Makes sure the Matrix intro always ends on the full VZI/DISRUPT logo: after the CSS intro ends, after 2.6s at most,
   on bfcache back/forward, with reduced motion, and if the header is re-rendered or re-shown later. Hover replay on desktop. */
(function(){
  var R=document.documentElement,DONE_MS=2600;
  function all(){return document.querySelectorAll('[data-vz-la]');}
  function finish(){R.classList.add('vz-la-seen');var l=all();for(var i=0;i<l.length;i++){l[i].classList.add('vz-la--done');l[i].classList.remove('vz-la--replay');}}
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce||!all().length){finish();}
  else{
    var t=setTimeout(finish,DONE_MS);
    document.addEventListener('animationend',function(e){if(e.animationName==='vz-la-base'&&!R.classList.contains('vz-la-seen')){clearTimeout(t);finish();}},true);
  }
  window.addEventListener('pageshow',function(e){if(e.persisted)finish();});
  document.addEventListener('visibilitychange',function(){if(!document.hidden&&R.classList.contains('vz-la-seen'))finish();});
  /* desktop hover replay (fine pointers only) */
  if(!reduce&&window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches){
    var busy=0;
    document.addEventListener('mouseover',function(e){var a=e.target&&e.target.closest&&e.target.closest('a.header-logo');if(!a||busy||!R.classList.contains('vz-la-seen'))return;
      var l=a.querySelector('[data-vz-la]');if(!l)return;busy=1;
      l.classList.remove('vz-la--done');l.classList.remove('vz-la--run');void l.offsetWidth;l.classList.add('vz-la--replay','vz-la--run');
      setTimeout(function(){finish();busy=0;},DONE_MS);},{passive:true});
  }
})();
